import React from 'react';
import styled from 'styled-components';
import TestimonialsSection from 'components/Marketing/TestimonialsSection';
import { Footer } from 'components/Footer/Footer';
import ForCreatorSectionOne from 'components/ForCreatorSections/ForCreatorSectionOne';
import ForCreatorSectionTwo from 'components/ForCreatorSections/ForCreatorSectionTwo';
import ForCreatorSectionThree from 'components/ForCreatorSections/ForCreatorSectionThree';
import ForCreatorSectionFour from 'components/ForCreatorSections/ForCreatorSectionFour';
import ForCreatorSectionEight from 'components/ForCreatorSections/ForCreatorSectionEight';
import SectionFive from 'components/ForCreatorSections/ForCreatorSectionFive';
import SectionSix from 'components/ForCreatorSections/ForCreatorSectionSix';
import Header, { HeaderVariant } from 'shared/Header';
import Spacer, { Size } from 'shared/Spacer';

export const Container = styled.div`
  background: black;
  display: flex;
  justify-content: center;
`;

export const MainWrap = styled.div`
  width: 1200px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    width: 100%;
    overflow: hidden;
  } ;
`;

export const getStaticProps = () => ({ props: {} });

const ForCreators = () => (
  <div>
    <Header variant={HeaderVariant.dark} />

    <Container>
      <MainWrap>
        <Spacer size={Size.spacing80} />
        <ForCreatorSectionOne />
        <ForCreatorSectionTwo />
        <ForCreatorSectionThree />
        <ForCreatorSectionFour />
        <SectionFive />
        <SectionSix />
        <TestimonialsSection />
        <ForCreatorSectionEight />
        <Footer background="#000" />
      </MainWrap>
    </Container>
  </div>
);

export default ForCreators;
